// extracted by mini-css-extract-plugin
export default {"visibilityTabs":"MyClientsPage_visibilityTabs__Ne+TK"};